import { jsx as t, jsxs as d } from "react/jsx-runtime";
import * as l from "@radix-ui/react-switch";
import { forwardRef as p, useId as w } from "react";
import { c as o } from "./cn-DlLpp5ix.js";
const b = {
  sm: "h-5 w-9",
  md: "h-6 w-11"
}, v = {
  sm: "h-4 w-4 data-[state=checked]:translate-x-4",
  md: "h-5 w-5 data-[state=checked]:translate-x-5"
}, k = p(
  function({ size: a = "md", label: s, description: e, className: m, id: h, disabled: n, ...u }, f) {
    const x = w(), r = h ?? `switch-${x}`, c = e ? `${r}-description` : void 0, i = /* @__PURE__ */ t(
      l.Root,
      {
        ref: f,
        id: r,
        disabled: n,
        "aria-describedby": c,
        className: o(
          "relative inline-flex shrink-0 cursor-pointer items-center rounded-full border border-transparent transition-colors",
          "focus-visible:outline-none focus-visible:shadow-ring-focus",
          b[a],
          // Off state — neutral elevated track.
          "bg-bg-elevated",
          // On state — accent fill.
          "data-[state=checked]:bg-accent",
          // Disabled.
          "disabled:cursor-not-allowed disabled:opacity-60",
          m
        ),
        ...u,
        children: /* @__PURE__ */ t(
          l.Thumb,
          {
            className: o(
              "pointer-events-none block translate-x-0.5 rounded-full bg-on-accent shadow-xs transition-transform",
              v[a]
            )
          }
        )
      }
    );
    return !s && !e ? i : /* @__PURE__ */ d("div", { className: "flex items-start gap-3", children: [
      /* @__PURE__ */ d("div", { className: "flex flex-col gap-0.5", children: [
        s ? /* @__PURE__ */ t(
          "label",
          {
            htmlFor: r,
            className: o(
              "cursor-pointer text-sm font-medium text-primary",
              n && "cursor-not-allowed opacity-60"
            ),
            children: s
          }
        ) : null,
        e ? /* @__PURE__ */ t("p", { id: c, className: "text-xs text-secondary", children: e }) : null
      ] }),
      /* @__PURE__ */ t("div", { className: "ml-auto", children: i })
    ] });
  }
);
export {
  k as S
};
//# sourceMappingURL=Switch-CI-zZhcx.js.map
